import React from "react";
import headingImg from "../../assets/img/heading-img.png";
import bannerBg from "../../assets/img/bannr-img.jpg";
import { NavLink } from "react-router-dom";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import blogDetail1 from "../../assets/img/blog-detail-img-1.jpg";
import blogDetail2 from "../../assets/img/blog-detail-img-2.jpg";
import blogDetail3 from "../../assets/img/blog-detail-img-3.jpg";
import blogDetail4 from "../../assets/img/blog-detail-img-4.jpg";
import "./Blog.css";
const Blog = () => {
  return (
    <div>
      <section
        className="bannr-section"
        style={{
          backgroundImage: `url(${bannerBg})`,
        }}
      >
        <div className="container">
          <div className="bannr-text">
            <img src={headingImg} alt="icon" />
            <h2>Our Blogs</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                Blogs
              </li>
            </ol>
          </div>
        </div>
      </section>

      <section className="gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="blog-two our-blog hoverimg">
                <figure>
                  <img src={blogDetail1} alt="img" />
                </figure>
                <div className="d-flex align-items-center">
                  <span>Quran Online</span>
                  <h6>jan 04 2024</h6>
                </div>
                <h5>
                  <NavLink to="/blog/1">
                    Embarking on a Journey of Reflection
                  </NavLink>
                  {/* <a href="#">Embarking on a Journey of Reflection</a> */}
                </h5>
                <div className="blog-man d-flex align-items-center">
                  <h6>
                    by<a href="#">Thomas Walimes</a>
                  </h6>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Loremod teminci didu ut labore et dolore magna
                  aliqua vulputate cursus a sit am velient taciti socio Etiam
                  ante ex fermen ore magna aliqua vulputate cursus a sit am
                  veliendio Sed non erat.
                </p>
                <a href="#">
                  <NavLink to="/blog/1">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                  <span>Read More</span>
                </a>
              </div>
              <div className="blog-two our-blog hoverimg">
                <figure>
                  <img src={blogDetail2} alt="img" />
                </figure>
                <div className="d-flex align-items-center">
                  <span>Quran Online</span>
                  <h6>jan 04 2024</h6>
                </div>
                <h5>
                  <NavLink to="/blog/1">
                    Embarking on a Journey of Reflection
                  </NavLink>
                </h5>
                <div className="blog-man d-flex align-items-center">
                  <h6>
                    by<a href="#">Thomas Walimes</a>
                  </h6>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Loremod teminci didu ut labore et dolore magna
                  aliqua vulputate cursus a sit am velient taciti socio Etiam
                  ante ex fermen ore magna aliqua vulputate cursus a sit am
                  veliendio Sed non erat.
                </p>
                <a href="#">
                  <NavLink to="/blog/1">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                  <span>Read More</span>
                </a>
              </div>
              <div className="blog-two our-blog hoverimg">
                <figure>
                  <img src={blogDetail3} alt="img" />
                </figure>
                <div className="d-flex align-items-center">
                  <span>Quran Online</span>
                  <h6>jan 04 2024</h6>
                </div>
                <h5>
                  <NavLink to="/blog/1">
                    Embarking on a Journey of Reflection
                  </NavLink>
                </h5>
                <div className="blog-man d-flex align-items-center">
                  <h6>
                    by<a href="#">Thomas Walimes</a>
                  </h6>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Loremod teminci didu ut labore et dolore magna
                  aliqua vulputate cursus a sit am velient taciti socio Etiam
                  ante ex fermen ore magna aliqua vulputate cursus a sit am
                  veliendio Sed non erat.
                </p>
                <a href="#">
                  <NavLink to="/blog/1">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                  <span>Read More</span>
                </a>
              </div>
              <div className="blog-two our-blog hoverimg">
                <figure>
                  <img src={blogDetail4} alt="img" />
                </figure>
                <div className="d-flex align-items-center">
                  <span>Quran Online</span>
                  <h6>jan 04 2024</h6>
                </div>
                <h5>
                  <NavLink to="/blog/1">
                    Embarking on a Journey of Reflection
                  </NavLink>
                </h5>
                <div className="blog-man d-flex align-items-center">
                  <h6>
                    by<a href="#">Thomas Walimes</a>
                  </h6>
                </div>
                <p>
                  Phasellus enim libero, blandit vel sapienvitae, condimen tum
                  ultricies magna Loremod teminci didu ut labore et dolore magna
                  aliqua vulputate cursus a sit am velient taciti socio Etiam
                  ante ex fermen ore magna aliqua vulputate cursus a sit am
                  veliendio Sed non erat.
                </p>
                <a href="#">
                  <NavLink to="/blog/1">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                  <span>Read More</span>
                </a>
              </div>

              <ul className="pagination">
                <li className="prev">
                  <a href="#">Prev</a>
                </li>
                <li>
                  <a href="#">1</a>
                </li>
                <li>
                  <a href="#">2</a>
                </li>
                <li>
                  <a href="#">3</a>
                </li>
                <li>
                  <a href="#">...</a>
                </li>
                <li>
                  <a href="#">18</a>
                </li>
                <li className="next">
                  <a href="#">next</a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4">
              <div className="sidebar">
                <h3>Recent Posts</h3>
                <div className="boder-bar"></div>
                <ul className="recent-post">
                  <li>
                    <img alt="recent-posts-img" src={blogDetail1} />
                    <div>
                      <a href="#">The Five Pillars are the core beliefs</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                  <li>
                    <img alt="recent-posts-img" src={blogDetail2} />
                    <div>
                      <a href="#">The Five Pillars are the core beliefs</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                  <li>
                    <img alt="recent-posts-img" src={blogDetail3} />
                    <div>
                      <a href="#">The Five Pillars are the core beliefs</a>
                      <span>March 02, 2024</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="sidebar">
                <h3>Categories</h3>
                <div className="boder-bar"></div>
                <ul className="categories">
                  <li>
                    <a href="#">
                      Classes<span>23</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Islamic<span>10</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Quran Tilawat<span>09</span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      Religious<span>14</span>
                    </a>
                  </li>
                  <li className="mb-0">
                    <a href="#">
                      Prayers<span>12</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
